import { config } from "../configs/config";
import { h } from "@/app/helpers";
import Axios from "axios";

export async function generatePaymentLink(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/buy-tokens/link`,
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}
